export const fontSize = {
  display1: "4.2rem",
  display2: "3.2rem",
  title1: "2.4rem",
  title2: "2rem",
  title3: "1.8rem",
  body: "1.6rem",
  caption: "1.4rem",
  small: "1.2rem",
  sup: "1.1rem",
};
